// Mirrors the server-side logic in server/routes/pole_checkups.js
const ACC_LIMIT = 50;   // metres
const DIST_LIMIT = 100; // metres

function haversineMeters(lat1, lon1, lat2, lon2) {
  const R = 6371000;
  const toRad = (v) => (v * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/**
 * @param {{ lat, lng, acc, poleLat, poleLng }} params
 * @returns {{ status: string, reason: string|null, distance_m: number|null }}
 */
export function localVerify({ lat, lng, acc, poleLat, poleLng }) {
  if (
    poleLat == null || poleLng == null ||
    !Number.isFinite(poleLat) || !Number.isFinite(poleLng)
  ) {
    return { status: 'skipped_offline', reason: 'no_pole_coords', distance_m: null };
  }

  if (lat == null || lng == null || !Number.isFinite(lat) || !Number.isFinite(lng)) {
    return { status: 'failed', reason: 'no_gps', distance_m: null };
  }

  const distance_m = haversineMeters(lat, lng, poleLat, poleLng);

  if (Number.isFinite(acc) && acc > ACC_LIMIT) {
    return { status: 'failed', reason: 'accuracy_bad', distance_m };
  }
  if (distance_m > DIST_LIMIT) {
    return { status: 'failed', reason: 'too_far', distance_m };
  }

  return { status: 'verified', reason: null, distance_m };
}
